var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 4.375V1.75C6.125 1.26675 6.51676 0.875 7 0.875H14C14.4833 0.875 14.875 1.26675 14.875 1.75V4.375H18.375C18.8583 4.375 19.25 4.76676 19.25 5.25V17.5C19.25 17.9833 18.8583 18.375 18.375 18.375H2.625C2.14175 18.375 1.75 17.9833 1.75 17.5V5.25C1.75 4.76676 2.14175 4.375 2.625 4.375H6.125ZM3.5 14V16.625H17.5V14H3.5ZM3.5 12.25H17.5V6.125H3.5V12.25ZM7.875 2.625V4.375H13.125V2.625H7.875ZM9.625 9.625H11.375V11.375H9.625V9.625Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.b923a101b1942d3d351eb19633221b5f.svg";
export { ForwardRef as ReactComponent };